import { LocaleString } from "models/locale";
import { doPatch } from "services/request";

export const adminDoPatchOrganization = async (name: LocaleString) => {
  await doPatch(`/admin/settings/organization`, { name });
};
